if (!customElements.get('header-megamenu')) {
  customElements.define(
    'header-megamenu',
    class HeaderMegamenu extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('[data-megamenu-link]');
        this.panel = this.querySelector('[data-megamenu-panel]');

        if (!this.link || !this.panel) return;

        this.link.setAttribute('aria-haspopup', 'true');
        this.link.setAttribute('aria-expanded', 'false');

        this.addEventListener('mouseenter', () => this.open());
        this.addEventListener('mouseleave', () => this.close());
        // Touch devices at desktop widths fire mouseenter and click on the
        // same tap: let the first tap open the panel, the second navigate.
        this.link.addEventListener('click', (event) => {
          if (!window.matchMedia('(hover: none)').matches) return;
          if (Date.now() - (this.openedAt || 0) < 500) event.preventDefault();
        });
        this.addEventListener('focusin', () => this.open());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.close();
        });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !this.classList.contains('is-open'))
            return;

          this.close();
          this.link.focus();
        });
      }

      open() {
        clearTimeout(this.closeTimer);
        if (!this.classList.contains('is-open')) this.openedAt = Date.now();
        this.classList.add('is-open');
        this.link.setAttribute('aria-expanded', 'true');
      }

      close() {
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => {
          this.classList.remove('is-open');
          this.link.setAttribute('aria-expanded', 'false');
        }, 120);
      }
    },
  );
}

if (!customElements.get('megamenu-accordion')) {
  customElements.define(
    'megamenu-accordion',
    class MegamenuAccordion extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-megamenu-toggle]');
        this.content = this.querySelector('[data-megamenu-content]');

        if (!this.toggle || !this.content) return;

        // The toggle is an anchor, not a button or summary: the menu drawer
        // script treats those as slide-in submenus, which is not what the
        // design wants here.
        this.toggle.addEventListener('click', (event) => {
          event.preventDefault();
          this.setOpen(!this.isOpen);
        });
        this.toggle.addEventListener('keydown', (event) => {
          if (event.key === ' ') {
            event.preventDefault();
            this.setOpen(!this.isOpen);
          }
        });

        this.setOpen(this.hasAttribute('open'));
      }

      get isOpen() {
        return this.classList.contains('is-open');
      }

      setOpen(open) {
        this.classList.toggle('is-open', open);
        this.toggle.setAttribute('aria-expanded', String(open));
        this.content.hidden = !open;
      }
    },
  );
}
